(function () {
  if (window.__ucAddToCartToastBound) return;
  window.__ucAddToCartToastBound = true;

  var hideTimer = null;
  var THRESHOLD = window.__ucShipThreshold || 10000;

  function message() {
    return (window.cartStrings && window.cartStrings.itemAdded) || 'Item added to your cart';
  }

  function unbindPosition(el) {
    if (!el || typeof el._ucUnbindPosition !== 'function') return;
    el._ucUnbindPosition();
    el._ucUnbindPosition = null;
  }

  function hideToast(el) {
    if (!el || !el.isConnected) return;
    unbindPosition(el);
    el.classList.remove('is-visible');
    window.setTimeout(function () {
      el.remove();
    }, 350);
  }

  function positionToast(el, anchor) {
    unbindPosition(el);

    if (!anchor || !anchor.isConnected) {
      el.classList.remove('uc-add-to-cart-toast--anchored');
      el.style.removeProperty('--uc-toast-x');
      el.style.removeProperty('--uc-toast-y');
      return;
    }

    el.classList.add('uc-add-to-cart-toast--anchored');

    function apply() {
      if (!anchor.isConnected || !el.isConnected) return;
      var rect = anchor.getBoundingClientRect();
      el.style.setProperty('--uc-toast-x', rect.left + rect.width / 2 + 'px');
      el.style.setProperty('--uc-toast-y', rect.top + 'px');
    }

    apply();
    requestAnimationFrame(apply);

    var onMove = function () {
      apply();
    };

    window.addEventListener('scroll', onMove, true);
    window.addEventListener('resize', onMove, { passive: true });

    el._ucUnbindPosition = function () {
      window.removeEventListener('scroll', onMove, true);
      window.removeEventListener('resize', onMove);
    };
  }

  function showToast(anchor) {
    var existing = document.querySelector('.uc-add-to-cart-toast');
    if (existing) {
      if (hideTimer) window.clearTimeout(hideTimer);
      hideToast(existing);
    }

    var el = document.createElement('div');
    el.className = 'uc-add-to-cart-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="uc-add-to-cart-toast__inner">' +
      '<span class="uc-add-to-cart-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M1 5.2L4.2 8.4L11 1.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg></span>' +
      '<p class="uc-add-to-cart-toast__text"></p>' +
      '</div>';

    el.querySelector('.uc-add-to-cart-toast__text').textContent = message();
    document.body.appendChild(el);
    positionToast(el, anchor);

    requestAnimationFrame(function () {
      positionToast(el, anchor);
      el.classList.add('is-visible');
    });

    hideTimer = window.setTimeout(function () {
      hideToast(el);
      hideTimer = null;
    }, 2600);
  }

  // Used by own-design confirm modal (direct AJAX add)
  window.__ucShowAddToCartToast = function (anchor) {
    showToast(anchor || null);
  };

  function shouldSkipToast(cartTotal) {
    if (window.__ucSuppressAddToCartToast) return true;
    if (document.querySelector('.uc-ship-celebration')) return true;
    if (typeof cartTotal !== 'number') return false;

    var last =
      typeof window.__ucShipGetLastTotal === 'function' ? window.__ucShipGetLastTotal() : null;
    return last !== null && last < THRESHOLD && cartTotal >= THRESHOLD;
  }

  function maybeShowToast(cartTotal, anchor) {
    if (shouldSkipToast(cartTotal)) return;
    showToast(anchor);
  }

  function onCartUpdate(event) {
    var forceToast = !!window.__ucPendingOwnDesignToast;
    if (forceToast) window.__ucPendingOwnDesignToast = false;

    if (!event || event.source !== 'product-form') return;
    if (!event.ucShowAddedToast && !forceToast) return;
    if (event.cartData && event.cartData.status) return;

    var anchor = event.ucAddToCartButton;
    var total = event.cartData && event.cartData.total_price;
    if (typeof total === 'number') {
      maybeShowToast(total, anchor);
      return;
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        maybeShowToast(cart && cart.total_price, anchor);
      })
      .catch(function () {
        maybeShowToast(undefined, anchor);
      });
  }

  function bind() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
